//#region Libraries
import { useEffect, useState } from "react";
//#endregion
//#region Services
import { requestGetEventById } from "services/events/aboutEvents";
import { requestGetTeacherById } from "services/general";
import { eventsSessionStorage } from "services/storage/events";
//#region Utils
import { EVENT_FORM_INITIAL_STATE } from "views/Eventos/components/FormCreateEvent/ManualLoadingForm/reducer/event.reducer";
import { EVENTS_CONSTANTS, PUBLIC_LOADS_IDS } from "config/constants";
//#endregion

const { EVENT_PERIOD_IDS } = EVENTS_CONSTANTS;

const useResumeData = ({
	loadingRequest,
	dataRelatedToForm: { eventGraphics, campusEnvironments, allCampus },
	loadedDataRelatedToEventForm,
	setForm,
	toStep,
	isCompletedForm,
}) => {
	//#region States
	const [eventResumeData, setEventResumeData] = useState(null);
	//#endregion
	//#region Effects
	useEffect(() => {
		if (!eventsSessionStorage.eventId.get()) return;
		if (loadedDataRelatedToEventForm) fillEventResumeData();
	}, [loadedDataRelatedToEventForm]);
	useEffect(() => {
		if (!eventResumeData || !setForm) return;
		fillForm();
	}, [eventResumeData]);
	//#endregion
	//#region Functions
	const fillForm = () => {
		const {
			title,
			description,
			standOutEvent,
			eventTypeId,
			eventSubtypeId,
			eventGraphicId,
			complementaryServiceAreaId,
			duration: { period, manyDays, onlyDay },
			hasWaitlist,
			linkInformacion,
			linkInformacionDesc,
			sectionSubtype,
		} = eventResumeData.step1;
		const {
			organizerId,
			teacher,
			payGradeId,
			locationId,
			zoomInscriptionTypeId,
			zoomTypeId,
			place,
			quantityVacancy,
			publicLoad,
			placeOrganization,
			autoCertificate,
		} = eventResumeData.step2;
		const { form } = EVENT_FORM_INITIAL_STATE;
		const newForm = {
			step1: {
				part1: {
					title,
					description,
					standOutEvent,
					linkInformacion,
					linkInformacionDesc,
				},
				part2: {
					...form.step1.part2,
					eventTypeId,
					eventSubtypeId,
					eventGraphicId,
					complementaryServiceAreaId,	
					sectionSubtype				
				},
				part3: {
					period,
					hasWaitlist,
					duration: {
						onlyDay: onlyDay
							? onlyDay
							: form.step1.part3.duration.onlyDay,
						manyDays: manyDays
							? manyDays
							: form.step1.part3.duration.manyDays,
					},
				},
			},
			step2: {
				part1: {
					organizerId: organizerId ? organizerId : 0,
					teacher: {
						search: !teacher.free
							? teacher.search
							: form.step2.part1.teacher.search,
						free: teacher.free
							? teacher.free
							: form.step2.part1.teacher.free,
					},
					payGradeId,
					placeOrganization: placeOrganization
						? {
								campus: {
									id: placeOrganization.campus.id,
									name: placeOrganization.campus.name,
								},
						  }
						: form.step2.part1.placeOrganization,
				},
				part2: {
					...form.step2.part2,
					locationId: locationId ? locationId : 0,
					zoomInscriptionTypeId: zoomInscriptionTypeId
						? zoomInscriptionTypeId
						: 0,
					zoomTypeId: zoomTypeId ? zoomTypeId : 0,
					place: place
						? {
								campus: {
									id: place.campus.id,
									name: place.campus.name,
								},
								environment: {
									inCampus: place.environment.inCampus
										? place.environment.inCampus
										: form.step2.part2.place.environment
												.inCampus,
									outCampus: place.environment.outCampus
										? place.environment.outCampus
										: form.step2.part2.place.environment
												.outCampus,
								},
						  }
						: form.step2.part2.place,
				},
				part3: {
					...form.step2.part3,
					quantityVacancy: quantityVacancy
						? quantityVacancy.toString()
						: "",
					publicLoad: {
						id: publicLoad.id,
						students: publicLoad.students
							? publicLoad.students
							: form.step2.part3.publicLoad.students,
						list: publicLoad.list
							? publicLoad.list
							: form.step2.part3.publicLoad.list,
					},
				},
				part4: {
					autoCertificate:
						autoCertificate || form.step2.part4.autoCertificate,
				},
			},
		};
		setForm(newForm);
		if (eventsSessionStorage.isDraftEvent.get()) {
			const isCompleted = isCompletedForm(newForm);
			if (isCompleted.step2) toStep(3);
			else if (isCompleted.step1) toStep(2);
			return;
		}
		const stepSessionStorage = eventsSessionStorage.currentEventFormStep.get();
		if (stepSessionStorage) {
			toStep(stepSessionStorage);
			return;
		}
		toStep(0);
		eventsSessionStorage.currentEventFormStep.set(0);
	};
	const fillEventResumeData = async () => {
		loadingRequest.show();
		const eventId = eventsSessionStorage.eventId.get();
		const data = await requestGetEventById(eventId);
		const newEventResumeData = {
			step1: {
				...fillEventDataStep1(data),
				id: eventId,
			},
			step2: await fillEventDataStep2(data),
		};
		loadingRequest.hide();
		setEventResumeData(newEventResumeData);
	};
	
	const fillEventDataStep1 = ({
		title,
		description,
		standOutEvent,
		eventGraphicId,
		complementaryServiceAreaId,
		onlyDay,
		manyDays,
		linkInformacion,
		linkInformacionDesc,
		sectionSubtype,
		seccionExtracurricularId,
		estadoTraslado
	}) => {
		const eventGraphic = eventGraphics.find(
			({ id }) => id === eventGraphicId
		);
		const { eventTypeId, eventSubtypeId } = eventGraphic;
		return {
			title,
			description,
			standOutEvent,
			eventTypeId,
			eventSubtypeId: eventSubtypeId ? eventSubtypeId : 0,
			eventGraphicId: eventGraphic.id,
			complementaryServiceAreaId,
			duration: {
				period: onlyDay
					? EVENT_PERIOD_IDS.ONLY_DAY
					: EVENT_PERIOD_IDS.MANY_DAYS,
				onlyDay: getOnlyDay(onlyDay),
				manyDays: getManyDays(manyDays),		
			},
			hasWaitlist: !!manyDays ? !!(manyDays.waitlist) : (!!onlyDay ? !!onlyDay.waitlist : false),
			linkInformacion: !!linkInformacion ? linkInformacion : "",
			linkInformacionDesc: !!linkInformacionDesc ? linkInformacionDesc : "",
			sectionSubtype: sectionSubtype ? sectionSubtype : 0,
			seccionExtracurricularId: seccionExtracurricularId ? seccionExtracurricularId : 0,
			estadoTraslado
		};
	};
	const fillEventDataStep2 = async ({
		organizerId,
		teacherCode,
		teacher,
		payGradeId,
		quantityVacancy,
		locationId,
		zoomInscriptionTypeId,
		environmentOutCampus,
		environmentId,
		floor,
		generalStudents,
		fileStudentsName,
		zoomLink,
		zoomTypeId,
		placeOrganization,
		autoCertificate,
	}) => {
		const {
			part4: { autoCertificate: defaultAutoCertificate },
		} = EVENT_FORM_INITIAL_STATE.form.step2;
		return {
			organizerId,
			teacher: await getTeacher(teacherCode, teacher),
			payGradeId: payGradeId || "",
			locationId: locationId || 0,
			zoomInscriptionTypeId: zoomInscriptionTypeId || 0,
			zoomLink,
			zoomTypeId,
			place: getPlaceFields(environmentOutCampus, environmentId, floor),
			quantityVacancy: quantityVacancy ? String(quantityVacancy) : "",
			publicLoad: getPublicLoad(generalStudents, fileStudentsName),
			placeOrganization: getPlaceOrganizationFields(placeOrganization),
			autoCertificate: autoCertificate || defaultAutoCertificate,
		};
	};
	function getPlaceOrganizationFields(placeOrganization) {	
		if (!placeOrganization.campus.id) return null;
		const campus = allCampus.find(({ id }) => id === placeOrganization.campus.id);
		return {
			campus: {
				id: campus.id,
				name: campus.name,
			},
		};
	}
	function getPublicLoad(generalStudents, fileStudentsName) {
		const { students, list } =
			EVENT_FORM_INITIAL_STATE.form.step2.part3.publicLoad;
		return {
			id:
				!generalStudents && !fileStudentsName
					? 0
					: generalStudents
					? PUBLIC_LOADS_IDS.GENERAL
					: PUBLIC_LOADS_IDS.FILE,
			students: generalStudents ? generalStudents : students,
			list: fileStudentsName
				? {
						studentsFile: {
							name: fileStudentsName || "",
							size: 0,
							base64: "",
						},
				  }
				: list,
		};
	}
	async function getTeacher(teacherCode, teacher) {
		if (teacherCode) {
			const teacherFullName = await requestGetTeacherById(teacherCode);
			return {
				search: {
					id: teacherCode,
					fullName: teacherFullName,
				},
				free: null,
			};
		} else if (teacher) {
			return {
				search: null,
				free: {
					fullName: teacher.fullName,
					accountId: teacher.accountId,
				},
			};
		}
		return EVENT_FORM_INITIAL_STATE.form.step2.part1.teacher;
	}
	function getPlaceFields(environmentOutCampus, environmentId, floor) {
		if (!environmentOutCampus && !environmentId) return null;
		const environmentInCampus = environmentId
			? campusEnvironments.find(({ id }) => {
					return id === environmentId;
			  })
			: null;
		const campusIdToSearch = environmentInCampus
			? environmentInCampus.campusId
			: environmentOutCampus.campusId;
		const campus = allCampus.find(({ id }) => id === campusIdToSearch);
		return {
			campus,
			environment: {
				inCampus: environmentInCampus
					? {
							id: environmentInCampus.id,
							address: environmentInCampus.address,
							floor,
					  }
					: null,
				outCampus: environmentOutCampus ? environmentOutCampus : null,
			},
		};
	}
	function getOnlyDay(onlyDay) {
		if (!onlyDay) return null;
		const { date, timeStart, timeEnd, waitlist } = onlyDay;
		return {
			date,
			time: {
				start: timeStart,
				end: timeEnd,
			},
			waitlist: !!waitlist ? waitlist : -1
		};
	}
	function getManyDays(manyDays) {
		if (!manyDays) return null;
		const days = [];
		const time = [];
		manyDays.time.forEach(timeByDay => {
			days.push(timeByDay.dayId);
			time.push(timeByDay);
		});
		const { dateStart, dateEnd, waitlist } = manyDays;
		const result = {
			date: {
				start: dateStart,
				end: dateEnd,
				waitlist: !!waitlist ? waitlist : -1
			},
			days,
			time,
		};
		return result;
	}
	//#endregion
	return {
		value: eventResumeData,
		fill: fillEventResumeData,
	};
};

export default useResumeData;
